import React from "react";

import "./styles.scss";

const SiteFooterCta = () => (
    <section className="site-footer-cta">
        <div className="inner site-footer-cta__inner">
            <div className="site-footer-cta__content">
                <h1 className="site-footer-cta__title">Want to learn more?</h1>
                <p className="site-footer-cta__text">
                    Arrange a call with us today to find out how we can help you
                    avail of the best opportunities in direct lending.
                </p>
            </div>

            <div className="site-footer-cta__actions">
                <a
                    className="hero-full__cta no-underline"
                    href="https://app.hubspot.com/meetings/iain7"
                    title="Schedule a call now"
                    target="_blank"
                >
                    <button className="btn-simple btn-lg btn-yellow btn-mobile">
                        Schedule a call now
                    </button>
                </a>
            </div>
        </div>
    </section>
);

export default SiteFooterCta;
